import { pythonApiClient } from "./python-http-client.service";
import { StockEvent, StockMovement, StockPage, StockRow } from "../models/inventory.model";
const base = (id: string) => `/api/ecomm/businesses/${encodeURIComponent(id)}/inventory`;
export const inventoryApi = {
  list: async (id: string) => (await pythonApiClient.get<StockPage>(base(id))).data,
  history: async (id: string, page: number) => (await pythonApiClient.get<{ items: StockEvent[]; total: number }>(`${base(id)}/history`, { params: { page } })).data,
  configure: async (id: string, row: StockRow) => (await pythonApiClient.put(`${base(id)}/${encodeURIComponent(row.productId)}/${encodeURIComponent(row.packId)}`, {
    tracked: row.tracked, lowStockThreshold: row.lowStockThreshold, unitCost: row.unitCost, supplier: row.supplier, location: row.location, revision: row.revision,
  })).data,
  move: async (id: string, data: StockMovement) => (await pythonApiClient.post(`${base(id)}/movements`, data)).data,
  track: async (id: string, tracked: boolean, rows: StockRow[], requestId: string) => (await pythonApiClient.post(`${base(id)}/tracking`, {
    requestId, tracked, lines: rows.map(({ productId, packId, revision }) => ({ productId, packId, revision })),
  })).data,
  previewImport: async (id: string, file: File) => {
    const data = new FormData(); data.append("file", file);
    return (await pythonApiClient.post<{ lines: StockMovement["lines"] }>(`${base(id)}/import-preview`, data)).data;
  },
};
